module.exports = __webpack_public_path__ + "static/media/Icone conclusion.093b420e.svg";